import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { ArrowDown } from 'lucide-react';
interface CaseStudyHeroProps {
  title: string;
  description: string;
  role: string;
  duration: string;
  tools: string[];
  industry: string;
  tags: string[];
  heroImage?: string;
}
export function CaseStudyHero({
  title,
  description,
  role,
  duration,
  tools,
  industry,
  tags,
  heroImage = 'https://i.imgur.com/sCbDZnG.png'
}: CaseStudyHeroProps) {
  const {
    ref,
    isVisible
  } = useScrollReveal(0);
  return <section className="relative min-h-screen flex flex-col justify-center px-6 pt-32 pb-16 overflow-hidden bg-black" data-id="element-77">
      {/* Full-Screen Background Image - Right Side Prominent */}
      <div className="absolute inset-0" data-id="element-78">
        <img src={heroImage} alt="" className="w-full h-full object-cover object-right" data-id="element-79" />
      </div>

      {/* Dark Gradient Overlay - Left Side Only */}
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-transparent" data-id="element-80" />

      {/* Content - Narrow Left Column */}
      <div ref={ref} className={`relative z-10 max-w-md transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`} data-id="element-81">
        {/* Title Section */}
        <div className="mb-12" data-id="element-82">
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-6 leading-tight" data-id="element-83">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-white to-gray-300" data-id="element-84">
              {title}
            </span>
          </h1>
          <p className="text-sm md:text-base text-gray-300 font-light leading-relaxed mb-4" data-id="element-85">
            {description}
          </p>

          {/* Tags */}
          <div className="flex flex-wrap gap-2" data-id="element-86">
            {tags.map(tag => <span key={tag} className="inline-block px-3 py-1.5 bg-white/10 backdrop-blur-sm rounded-full text-xs text-white font-medium" data-id="element-87">
                {tag}
              </span>)}
          </div>
        </div>

        {/* Metadata Grid */}
        <div className="grid grid-cols-2 gap-6 py-6 border-t border-white/20" data-id="element-88">
          <div data-id="element-89">
            <h3 className="text-xs text-gray-400 uppercase tracking-wider mb-1 font-medium" data-id="element-90">
              My Role
            </h3>
            <p className="text-white text-sm font-medium" data-id="element-91">{role}</p>
          </div>
          <div data-id="element-92">
            <h3 className="text-xs text-gray-400 uppercase tracking-wider mb-1 font-medium" data-id="element-93">
              Duration
            </h3>
            <p className="text-white text-sm font-medium" data-id="element-94">{duration}</p>
          </div>
          <div data-id="element-95">
            <h3 className="text-xs text-gray-400 uppercase tracking-wider mb-1 font-medium" data-id="element-96">
              Industry
            </h3>
            <p className="text-white text-sm font-medium" data-id="element-97">{industry}</p>
          </div>
          <div data-id="element-98">
            <h3 className="text-xs text-gray-400 uppercase tracking-wider mb-1 font-medium" data-id="element-99">
              Tools
            </h3>
            <p className="text-white text-sm font-medium" data-id="element-100">{tools.join(', ')}</p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce opacity-30 z-10" data-id="element-101">
        <ArrowDown className="text-white w-6 h-6" data-id="element-102" />
      </div>
    </section>;
}